import {
  Card,
  CardFooter,
  CardHeader,
} from "@/components/ui/v2/card";
import { Skeleton } from "@/components/ui/v2/skeleton";

function CampaignCardSkeleton() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-6 flex-1" />
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
        <Skeleton className="h-4 w-24 mt-2" />
      </CardHeader>
      <CardFooter>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-6 w-20 rounded-full" />
          <Skeleton className="h-6 w-24 rounded-full" />
        </div>
      </CardFooter>
    </Card>
  );
}

export default CampaignCardSkeleton;
